import React, { useEffect, useState } from 'react';
import { db } from '../firebase/firebaseConfig';
import {
  collection,
  query,
  where,
  onSnapshot
} from 'firebase/firestore';

const LostItems = () => {
  const [lostItems, setLostItems] = useState([]);
  const [approvedItemIds, setApprovedItemIds] = useState([]);

  useEffect(() => {
    // Listen for approved claims
    const claimsQuery = query(collection(db, 'claims'), where('status', '==', 'approved'));
    const unsubscribeClaims = onSnapshot(claimsQuery, (snapshot) => {
      const ids = snapshot.docs.map(doc => doc.data().itemId);
      setApprovedItemIds(ids);
    });

    // Listen for lost items
    const lostItemsQuery = query(collection(db, 'lostItems'), where('reportType', '==', 'lost'));
    const unsubscribeLost = onSnapshot(lostItemsQuery, (snapshot) => {
      const allItems = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setLostItems(allItems);
    });

    return () => {
      unsubscribeClaims();
      unsubscribeLost();
    };
  }, []);

  // Filter out approved claimed items
  const filteredLostItems = lostItems.filter(item => !approvedItemIds.includes(item.id));

  return (
    <div className="lost-items-container" style={{ padding: '2rem' }}>
      <h2>📦 Reported Lost Items</h2>
      {filteredLostItems.length === 0 ? (
        <p>No lost items reported yet.</p>
      ) : (
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          {filteredLostItems.map(item => (
            <li
              key={item.id}
              style={{
                background: '#f8f8f8',
                padding: '1rem',
                marginBottom: '1rem',
                borderRadius: '10px',
                border: '1px solid #ddd'
              }}
            >
              {/* 👇 Display the uploaded image if available */}
              {item.imageUrl && (
                <img
                  src={item.imageUrl}
                  alt={item.itemName}
                  style={{
                    width: '30%',
                    maxHeight: '200px',
                    objectFit: 'cover',
                    borderRadius: '8px',
                    marginBottom: '1rem'
                  }}
                />
              )}

              <h3>{item.itemName}</h3>
              <p><strong>Date Lost:</strong> {item.dateLost?.toDate?.().toLocaleDateString?.() || item.dateLost}</p>
              <p><strong>Description:</strong> {item.description}</p>
              <p><strong>Location:</strong> {item.location}</p>
              <p><strong>Reported by:</strong> {item.yourName}</p>
              <p><strong>Status:</strong> {item.itemStatus}</p>
              <p><strong>Message:</strong> {item.message || 'None'}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LostItems;
